import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import { map, take } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@angular/forms';
import { Validators, ReactiveFormsModule } from '@angular/forms';
import * as errorUtils from 'error-message-utility';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject, combineLatest } from 'rxjs';
import { getSubTaskDetails, getStepDetails, updateStepStatus } from 'visa-store';
import * as i6 from '@ngrx/store';
import { select } from '@ngrx/store';
import { map as map$1 } from 'rxjs/internal/operators/map';
import { MarkDirtyFormAction, MarkCleanFormAction } from 'dirty-check-store';
import { UploadSignatureLibraryComponent, UploadSignatureLibraryModule } from 'upload-signature-library';
import { CustomErrorToastComponent } from 'custom-error-toast';
import * as i2 from 'base-consulate-address-library';
import * as i4 from 'primeng/dynamicdialog';
import * as i5 from 'ngx-toastr';
import * as i7 from 'step-status-update-payload-service';
import * as i8 from 'cache-country-list';
import * as i9 from 'reference-library';
import * as i10 from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import * as i11 from '@angular/common';
import * as i12 from 'primeng/button';
import * as i13 from 'primeng/radiobutton';
import * as i14 from 'primeng/inputtext';
import * as i15 from 'primeng/dropdown';
import * as i16 from '@angular/material/icon';
import * as i17 from 'primeng/inputmask';
import { PrimengLibraryModule } from 'primeng-library';

class CardInformationService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getEnotificationAndCCDetails(visaType, caseType, caseId) {
        return this.httpClient.get(`/${visaType}/${caseType}/${caseId}/enotificationAndCCDetails`).pipe(map((response) => {
            if (response.status === 200 || response.status === 204) {
                return response;
            }
        }));
    }
    saveEnotificationAndCCDetails(visaType, caseType, caseId, payload) {
        return this.httpClient.post(`/${visaType}/${caseType}/${caseId}/enotificationAndCCDetails`, payload).pipe(map((response) => {
            if (response.status === 200 || response.status === 204) {
                return response;
            }
        }));
    }
    postSignatureImage(visaType, caseType, caseId, payload) {
        // console.log('post data', payload);
        //return this.httpClient.post(`/petition/${petitionId}/profile/signpic`, payload).pipe(
        return this.httpClient.post(`/${visaType}/${caseType}/${caseId}/profile/signpic/save`, payload).pipe(map((data) => {
            // console.log('from servpicpost', data);
            return data;
        }));
    }
}
CardInformationService.ɵfac = function CardInformationService_Factory(t) { return new (t || CardInformationService)(i0.ɵɵinject(i1.HttpClient)); };
CardInformationService.ɵprov = i0.ɵɵdefineInjectable({ token: CardInformationService, factory: CardInformationService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardInformationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function CardInformationComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelementStart(1, "div", 11);
    i0.ɵɵelementStart(2, "label", 12);
    i0.ɵɵtext(3, " Do you want to use your credit card for fee payment? ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵelementStart(5, "small");
    i0.ɵɵtext(6, "The credit card must be issued by a US bank");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 13);
    i0.ɵɵelementStart(8, "p-radioButton", 14);
    i0.ɵɵlistener("onClick", function CardInformationComponent_div_5_Template_p_radioButton_onClick_8_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.handleCreditCardSelection(true); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "p-radioButton", 15);
    i0.ɵɵlistener("onClick", function CardInformationComponent_div_5_Template_p_radioButton_onClick_9_listener() { i0.ɵɵrestoreView(_r5); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.handleCreditCardSelection(false); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("disabled", ctx_r0.disabledControls)("value", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r0.disabledControls)("value", false);
} }
function CardInformationComponent_div_6_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r7.getGlobalErrorMessages("REQUIRED"), " ");
} }
function CardInformationComponent_div_6_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r8.getGlobalErrorMessages("REQUIRED"), " ");
} }
function CardInformationComponent_div_6_div_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r9.getGlobalErrorMessages("REQUIRED"), " ");
} }
function CardInformationComponent_div_6_div_34_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r10.getGlobalErrorMessages("REQUIRED"), " ");
} }
function CardInformationComponent_div_6_div_43_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r11.getGlobalErrorMessages("REQUIRED"), " ");
} }
function CardInformationComponent_div_6_div_58_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r12.getGlobalErrorMessages("REQUIRED"), " ");
} }
function CardInformationComponent_div_6_div_63_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r13.getGlobalErrorMessages("REQUIRED"), " ");
} }
function CardInformationComponent_div_6_div_68_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r14.getGlobalErrorMessages("REQUIRED"), " ");
} }
function CardInformationComponent_div_6_div_69_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r15.getGlobalErrorMessages("INVALID_NUMBER"), " ");
} }
function CardInformationComponent_div_6_img_83_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 60);
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("src", ctx_r16.signatureImage, i0.ɵɵsanitizeUrl);
} }
function CardInformationComponent_div_6_div_89_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r17.getGlobalErrorMessages("REQUIRED"), " ");
} }
function CardInformationComponent_div_6_div_94_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r18.getGlobalErrorMessages("REQUIRED"), " ");
} }
function CardInformationComponent_div_6_div_95_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r19.getGlobalErrorMessages("INVALID_EMAIL"), " ");
} }
function CardInformationComponent_div_6_ng_container_118_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r30.getGlobalErrorMessages("REQUIRED"), "");
} }
function CardInformationComponent_div_6_ng_container_118_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Enter a four-digit number.");
    i0.ɵɵelementEnd();
} }
function CardInformationComponent_div_6_ng_container_118_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CardInformationComponent_div_6_ng_container_118_div_1_Template, 2, 1, "div", 53);
    i0.ɵɵtemplate(2, CardInformationComponent_div_6_ng_container_118_div_2_Template, 2, 0, "div", 53);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r20.f.ccNumber1.errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r20.f.ccNumber1.errors.pattern);
} }
function CardInformationComponent_div_6_ng_container_120_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r32.getGlobalErrorMessages("REQUIRED"), "");
} }
function CardInformationComponent_div_6_ng_container_120_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Enter a four-digit number.");
    i0.ɵɵelementEnd();
} }
function CardInformationComponent_div_6_ng_container_120_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CardInformationComponent_div_6_ng_container_120_div_1_Template, 2, 1, "div", 53);
    i0.ɵɵtemplate(2, CardInformationComponent_div_6_ng_container_120_div_2_Template, 2, 0, "div", 53);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r21.f.ccNumber2.errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r21.f.ccNumber2.errors.pattern);
} }
function CardInformationComponent_div_6_ng_container_122_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r34.getGlobalErrorMessages("REQUIRED"), "");
} }
function CardInformationComponent_div_6_ng_container_122_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Enter a four-digit number.");
    i0.ɵɵelementEnd();
} }
function CardInformationComponent_div_6_ng_container_122_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CardInformationComponent_div_6_ng_container_122_div_1_Template, 2, 1, "div", 53);
    i0.ɵɵtemplate(2, CardInformationComponent_div_6_ng_container_122_div_2_Template, 2, 0, "div", 53);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r22.f.ccNumber3.errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r22.f.ccNumber3.errors.pattern);
} }
function CardInformationComponent_div_6_ng_container_124_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r36.getGlobalErrorMessages("REQUIRED"), "");
} }
function CardInformationComponent_div_6_ng_container_124_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Enter a four-digit number.");
    i0.ɵɵelementEnd();
} }
function CardInformationComponent_div_6_ng_container_124_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CardInformationComponent_div_6_ng_container_124_div_1_Template, 2, 1, "div", 53);
    i0.ɵɵtemplate(2, CardInformationComponent_div_6_ng_container_124_div_2_Template, 2, 0, "div", 53);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r23.f.ccNumber4.errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r23.f.ccNumber4.errors.pattern);
} }
function CardInformationComponent_div_6_div_129_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r24.getGlobalErrorMessages("REQUIRED"), " ");
} }
function CardInformationComponent_div_6_div_130_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵtext(1, " Enter Valid Expiry Date ");
    i0.ɵɵelementEnd();
} }
function CardInformationComponent_div_6_div_134_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 61);
    i0.ɵɵelement(1, "p-radioButton", 62);
    i0.ɵɵelementStart(2, "label", 63);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r38 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("inputId", item_r38.code)("value", item_r38.code);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", item_r38.code);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r38.name);
} }
function CardInformationComponent_div_6_div_135_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r27.getGlobalErrorMessages("REQUIRED"), " ");
} }
function CardInformationComponent_div_6_div_141_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r28.getGlobalErrorMessages("REQUIRED"), " ");
} }
function CardInformationComponent_div_6_div_142_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r29.getGlobalErrorMessages("INVALID_NUMBER"), " ");
} }
const _c0 = function (a0) { return { "ssn-input-hide": a0 }; };
function CardInformationComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelementStart(1, "label", 17);
    i0.ɵɵtext(2, "Applicant\u2019s / Petitioner\u2019s / Requestor\u2019s Full Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 3);
    i0.ɵɵelementStart(4, "div", 18);
    i0.ɵɵelementStart(5, "label", 19);
    i0.ɵɵtext(6, " Given Name (First Name) ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "input", 20);
    i0.ɵɵtemplate(8, CardInformationComponent_div_6_div_8_Template, 2, 1, "div", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 18);
    i0.ɵɵelementStart(10, "label", 22);
    i0.ɵɵtext(11, " Middle Name (if any) ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "input", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 18);
    i0.ɵɵelementStart(14, "label", 19);
    i0.ɵɵtext(15, " Family Name (Last Name) ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(16, "input", 24);
    i0.ɵɵtemplate(17, CardInformationComponent_div_6_div_17_Template, 2, 1, "div", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "label", 17);
    i0.ɵɵtext(19, "Credit Card Billing Information");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 3);
    i0.ɵɵelementStart(21, "div", 18);
    i0.ɵɵelementStart(22, "label", 19);
    i0.ɵɵtext(23, " Given Name (First Name) ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(24, "input", 25);
    i0.ɵɵtemplate(25, CardInformationComponent_div_6_div_25_Template, 2, 1, "div", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "div", 18);
    i0.ɵɵelementStart(27, "label", 22);
    i0.ɵɵtext(28, " Middle Name (if any) ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(29, "input", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "div", 18);
    i0.ɵɵelementStart(31, "label", 19);
    i0.ɵɵtext(32, " Family Name (Last Name) ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(33, "input", 27);
    i0.ɵɵtemplate(34, CardInformationComponent_div_6_div_34_Template, 2, 1, "div", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(35, "div", 16);
    i0.ɵɵelementStart(36, "label", 17);
    i0.ɵɵtext(37, "Credit Card Holder\u2019s Billing Information");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(38, "div", 3);
    i0.ɵɵelementStart(39, "div", 18);
    i0.ɵɵelementStart(40, "label", 19);
    i0.ɵɵtext(41, " Street Number and Name ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(42, "input", 28);
    i0.ɵɵtemplate(43, CardInformationComponent_div_6_div_43_Template, 2, 1, "div", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(44, "div", 18);
    i0.ɵɵelementStart(45, "div", 13);
    i0.ɵɵelement(46, "p-radioButton", 29);
    i0.ɵɵelement(47, "p-radioButton", 30);
    i0.ɵɵelement(48, "p-radioButton", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(49, "div", 18);
    i0.ɵɵelementStart(50, "label", 22);
    i0.ɵɵtext(51, " Number ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(52, "input", 32);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(53, "div", 3);
    i0.ɵɵelementStart(54, "div", 18);
    i0.ɵɵelementStart(55, "label", 19);
    i0.ɵɵtext(56, " City ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(57, "input", 33);
    i0.ɵɵtemplate(58, CardInformationComponent_div_6_div_58_Template, 2, 1, "div", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(59, "div", 34);
    i0.ɵɵelementStart(60, "label", 19);
    i0.ɵɵtext(61, "State");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(62, "p-dropdown", 35);
    i0.ɵɵtemplate(63, CardInformationComponent_div_6_div_63_Template, 2, 1, "div", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(64, "div", 18);
    i0.ɵɵelementStart(65, "label", 19);
    i0.ɵɵtext(66, " Zipcode ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(67, "input", 36);
    i0.ɵɵtemplate(68, CardInformationComponent_div_6_div_68_Template, 2, 1, "div", 21);
    i0.ɵɵtemplate(69, CardInformationComponent_div_6_div_69_Template, 2, 1, "div", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(70, "label", 17);
    i0.ɵɵtext(71, "Credit Card Holder\u2019s Signature and Contact Information");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(72, "br");
    i0.ɵɵelementStart(73, "div", 3);
    i0.ɵɵelementStart(74, "div", 37);
    i0.ɵɵelementStart(75, "label");
    i0.ɵɵelementStart(76, "b");
    i0.ɵɵtext(77, "Signature");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(78, "p");
    i0.ɵɵelementStart(79, "button", 38);
    i0.ɵɵlistener("click", function CardInformationComponent_div_6_Template_button_click_79_listener() { i0.ɵɵrestoreView(_r41); const ctx_r40 = i0.ɵɵnextContext(); return ctx_r40.uploadSignatureImage(); });
    i0.ɵɵelementStart(80, "span");
    i0.ɵɵtext(81, "Upload Signature");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(82, "div", 39);
    i0.ɵɵtemplate(83, CardInformationComponent_div_6_img_83_Template, 1, 1, "img", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(84, "div", 3);
    i0.ɵɵelementStart(85, "div", 41);
    i0.ɵɵelementStart(86, "label", 19);
    i0.ɵɵtext(87, " Daytime Telephone Number ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(88, "input", 42);
    i0.ɵɵtemplate(89, CardInformationComponent_div_6_div_89_Template, 2, 1, "div", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(90, "div", 41);
    i0.ɵɵelementStart(91, "label", 19);
    i0.ɵɵtext(92, " Email Address ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(93, "input", 43);
    i0.ɵɵtemplate(94, CardInformationComponent_div_6_div_94_Template, 2, 1, "div", 21);
    i0.ɵɵtemplate(95, CardInformationComponent_div_6_div_95_Template, 2, 1, "div", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(96, "label", 17);
    i0.ɵɵtext(97, "Credit Card Information");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(98, "div", 3);
    i0.ɵɵelementStart(99, "div", 41);
    i0.ɵɵelementStart(100, "label", 19);
    i0.ɵɵtext(101, " Credit Card Number ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(102, "div", 16);
    i0.ɵɵelementStart(103, "div", 44);
    i0.ɵɵelement(104, "input", 45);
    i0.ɵɵelement(105, "span", 46);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(106, "div", 44);
    i0.ɵɵelement(107, "input", 47);
    i0.ɵɵelement(108, "span", 46);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(109, "div", 44);
    i0.ɵɵelement(110, "input", 48);
    i0.ɵɵelement(111, "span", 46);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(112, "div", 44);
    i0.ɵɵelement(113, "input", 49);
    i0.ɵɵelementStart(114, "span", 50);
    i0.ɵɵelementStart(115, "mat-icon", 51);
    i0.ɵɵlistener("click", function CardInformationComponent_div_6_Template_mat_icon_click_115_listener() { i0.ɵɵrestoreView(_r41); const ctx_r42 = i0.ɵɵnextContext(); return ctx_r42.ccNumber1_hide = !ctx_r42.ccNumber1_hide; });
    i0.ɵɵtext(116);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(117, "div", 52);
    i0.ɵɵtemplate(118, CardInformationComponent_div_6_ng_container_118_Template, 3, 2, "ng-container", 53);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(119, "div", 52);
    i0.ɵɵtemplate(120, CardInformationComponent_div_6_ng_container_120_Template, 3, 2, "ng-container", 53);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(121, "div", 52);
    i0.ɵɵtemplate(122, CardInformationComponent_div_6_ng_container_122_Template, 3, 2, "ng-container", 53);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(123, "div", 52);
    i0.ɵɵtemplate(124, CardInformationComponent_div_6_ng_container_124_Template, 3, 2, "ng-container", 53);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(125, "div", 54);
    i0.ɵɵelementStart(126, "label", 19);
    i0.ɵɵtext(127, " Expiry Date ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(128, "p-inputMask", 55);
    i0.ɵɵlistener("onComplete", function CardInformationComponent_div_6_Template_p_inputMask_onComplete_128_listener() { i0.ɵɵrestoreView(_r41); const ctx_r43 = i0.ɵɵnextContext(); return ctx_r43.validateExpiryDate(); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(129, CardInformationComponent_div_6_div_129_Template, 2, 1, "div", 21);
    i0.ɵɵtemplate(130, CardInformationComponent_div_6_div_130_Template, 2, 0, "div", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(131, "div", 18);
    i0.ɵɵelementStart(132, "label", 56);
    i0.ɵɵtext(133, " Credit Card Type ");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(134, CardInformationComponent_div_6_div_134_Template, 4, 4, "div", 57);
    i0.ɵɵtemplate(135, CardInformationComponent_div_6_div_135_Template, 2, 1, "div", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(136, "div", 3);
    i0.ɵɵelementStart(137, "div", 41);
    i0.ɵɵelementStart(138, "label", 19);
    i0.ɵɵtext(139, " Authorized Payment Amount $ ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(140, "input", 58);
    i0.ɵɵtemplate(141, CardInformationComponent_div_6_div_141_Template, 2, 1, "div", 21);
    i0.ɵɵtemplate(142, CardInformationComponent_div_6_div_142_Template, 2, 1, "div", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("readonly", ctx_r1.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.cardInfoForm.get("firstName").touched && (ctx_r1.cardInfoForm.get("firstName").errors == null ? null : ctx_r1.cardInfoForm.get("firstName").errors.required));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", ctx_r1.disabledControls);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", ctx_r1.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.cardInfoForm.get("lastName").touched && (ctx_r1.cardInfoForm.get("lastName").errors == null ? null : ctx_r1.cardInfoForm.get("lastName").errors.required));
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("readonly", ctx_r1.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.cardInfoForm.get("ccHolderFirstName").touched && (ctx_r1.cardInfoForm.get("ccHolderFirstName").errors == null ? null : ctx_r1.cardInfoForm.get("ccHolderFirstName").errors.required));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", ctx_r1.disabledControls);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", ctx_r1.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.cardInfoForm.get("ccHolderLastName").touched && (ctx_r1.cardInfoForm.get("ccHolderLastName").errors == null ? null : ctx_r1.cardInfoForm.get("ccHolderLastName").errors.required));
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("readonly", ctx_r1.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.cardInfoForm.get("addressLine1").touched && (ctx_r1.cardInfoForm.get("addressLine1").errors == null ? null : ctx_r1.cardInfoForm.get("addressLine1").errors.required));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", ctx_r1.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r1.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r1.disabledControls);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", ctx_r1.disabledControls);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("readonly", ctx_r1.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.cardInfoForm.get("city").touched && (ctx_r1.cardInfoForm.get("city").errors == null ? null : ctx_r1.cardInfoForm.get("city").errors.required));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", ctx_r1.disabledControls)("options", ctx_r1.listStates);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.cardInfoForm.get("stateProvinceName").touched && (ctx_r1.cardInfoForm.get("stateProvinceName").errors == null ? null : ctx_r1.cardInfoForm.get("stateProvinceName").errors.required));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", ctx_r1.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.cardInfoForm.get("postCode").touched && (ctx_r1.cardInfoForm.get("postCode").errors == null ? null : ctx_r1.cardInfoForm.get("postCode").errors.required));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.cardInfoForm.get("postCode").touched && (ctx_r1.cardInfoForm.get("postCode").errors == null ? null : ctx_r1.cardInfoForm.get("postCode").errors.pattern));
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("ngClass", ctx_r1.disabledControls ? "btn-success button-width-icon-left mr-3 pl-4 pr-4 btn-success_disabled save-btn" : "btn-success button-width-icon-left mr-3  pl-4 pr-4 save-btn")("disabled", ctx_r1.disabledControls);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r1.signatureImage);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("readonly", ctx_r1.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.cardInfoForm.get("ccHolderPhoneNumber").touched && (ctx_r1.cardInfoForm.get("ccHolderPhoneNumber").errors == null ? null : ctx_r1.cardInfoForm.get("ccHolderPhoneNumber").errors.required));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", ctx_r1.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.cardInfoForm.get("ccHolderEmailAddress").touched && (ctx_r1.cardInfoForm.get("ccHolderEmailAddress").errors == null ? null : ctx_r1.cardInfoForm.get("ccHolderEmailAddress").errors.required));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.cardInfoForm.get("ccHolderEmailAddress").touched && (ctx_r1.cardInfoForm.get("ccHolderEmailAddress").errors == null ? null : ctx_r1.cardInfoForm.get("ccHolderEmailAddress").errors.pattern));
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(48, _c0, !ctx_r1.ccNumber1_hide));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(50, _c0, !ctx_r1.ccNumber1_hide));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(52, _c0, !ctx_r1.ccNumber1_hide));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.ccNumber1_hide ? "visibility" : "visibility_off", "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.f.ccNumber1.invalid && (ctx_r1.f.ccNumber1.dirty || ctx_r1.f.ccNumber1.touched));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.f.ccNumber2.invalid && (ctx_r1.f.ccNumber2.dirty || ctx_r1.f.ccNumber2.touched));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.f.ccNumber3.invalid && (ctx_r1.f.ccNumber3.dirty || ctx_r1.f.ccNumber3.touched));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.f.ccNumber4.invalid && (ctx_r1.f.ccNumber4.dirty || ctx_r1.f.ccNumber4.touched));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", ctx_r1.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.cardInfoForm.get("expiryDate").touched && (ctx_r1.cardInfoForm.get("expiryDate").errors == null ? null : ctx_r1.cardInfoForm.get("expiryDate").errors.required));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.cardInfoForm.get("expiryDate").touched && !ctx_r1.validExpiryDate);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r1.creditCardTypeArr);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.cardInfoForm.get("creditCardType").touched && (ctx_r1.cardInfoForm.get("creditCardType").errors == null ? null : ctx_r1.cardInfoForm.get("creditCardType").errors.required));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("readonly", ctx_r1.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.cardInfoForm.get("amount").touched && (ctx_r1.cardInfoForm.get("amount").errors == null ? null : ctx_r1.cardInfoForm.get("amount").errors.required));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.cardInfoForm.get("amount").touched && (ctx_r1.cardInfoForm.get("amount").errors == null ? null : ctx_r1.cardInfoForm.get("amount").errors.pattern));
} }
function CardInformationComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r45 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelementStart(1, "div", 11);
    i0.ɵɵelementStart(2, "label", 12);
    i0.ɵɵtext(3, " Do you want to opt for e-Notification from USCIS? ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 13);
    i0.ɵɵelementStart(5, "p-radioButton", 64);
    i0.ɵɵlistener("onClick", function CardInformationComponent_div_7_Template_p_radioButton_onClick_5_listener() { i0.ɵɵrestoreView(_r45); const ctx_r44 = i0.ɵɵnextContext(); return ctx_r44.handleCreditCardSelection(true, "ENOTIFY"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "p-radioButton", 65);
    i0.ɵɵlistener("onClick", function CardInformationComponent_div_7_Template_p_radioButton_onClick_6_listener() { i0.ɵɵrestoreView(_r45); const ctx_r46 = i0.ɵɵnextContext(); return ctx_r46.handleCreditCardSelection(false, "ENOTIFY"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("disabled", ctx_r2.disabledControls)("value", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r2.disabledControls)("value", false);
} }
function CardInformationComponent_div_8_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r47 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r47.getGlobalErrorMessages("REQUIRED"), " ");
} }
function CardInformationComponent_div_8_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r48 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r48.getGlobalErrorMessages("REQUIRED"), " ");
} }
function CardInformationComponent_div_8_div_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r49 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r49.getGlobalErrorMessages("REQUIRED"), " ");
} }
function CardInformationComponent_div_8_div_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r50 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r50.getGlobalErrorMessages("INVALID_EMAIL"), " ");
} }
function CardInformationComponent_div_8_div_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r51 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r51.getGlobalErrorMessages("REQUIRED"), " ");
} }
function CardInformationComponent_div_8_div_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r52 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r52.getGlobalErrorMessages("INVALID_NUMBER"), " ");
} }
function CardInformationComponent_div_8_div_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r53 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r53.getGlobalErrorMessages("MAXLENGTH") + "10", " ");
} }
function CardInformationComponent_div_8_div_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r54 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r54.getGlobalErrorMessages("MINLENGTH") + "10 Numbers", " ");
} }
function CardInformationComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelementStart(1, "label", 17);
    i0.ɵɵtext(2, "Applicant\u2019s / Petitioner\u2019s / Requestor\u2019s Full Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 3);
    i0.ɵɵelementStart(4, "div", 18);
    i0.ɵɵelementStart(5, "label", 19);
    i0.ɵɵtext(6, " Given Name (First Name) ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "input", 66);
    i0.ɵɵtemplate(8, CardInformationComponent_div_8_div_8_Template, 2, 1, "div", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 18);
    i0.ɵɵelementStart(10, "label", 22);
    i0.ɵɵtext(11, " Middle Name (if any) ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "input", 67);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 18);
    i0.ɵɵelementStart(14, "label", 19);
    i0.ɵɵtext(15, " Family Name (Last Name) ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(16, "input", 68);
    i0.ɵɵtemplate(17, CardInformationComponent_div_8_div_17_Template, 2, 1, "div", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 16);
    i0.ɵɵelementStart(19, "div", 41);
    i0.ɵɵelementStart(20, "label", 19);
    i0.ɵɵtext(21, " Email Address ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(22, "input", 69);
    i0.ɵɵtemplate(23, CardInformationComponent_div_8_div_23_Template, 2, 1, "div", 21);
    i0.ɵɵtemplate(24, CardInformationComponent_div_8_div_24_Template, 2, 1, "div", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "div", 41);
    i0.ɵɵelementStart(26, "label", 19);
    i0.ɵɵtext(27, " Mobile Phone Number ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(28, "input", 70);
    i0.ɵɵtemplate(29, CardInformationComponent_div_8_div_29_Template, 2, 1, "div", 21);
    i0.ɵɵtemplate(30, CardInformationComponent_div_8_div_30_Template, 2, 1, "div", 21);
    i0.ɵɵtemplate(31, CardInformationComponent_div_8_div_31_Template, 2, 1, "div", 21);
    i0.ɵɵtemplate(32, CardInformationComponent_div_8_div_32_Template, 2, 1, "div", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("readonly", ctx_r3.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.cardInfoForm.get("enotificationFirstName").touched && (ctx_r3.cardInfoForm.get("enotificationFirstName").errors == null ? null : ctx_r3.cardInfoForm.get("enotificationFirstName").errors.required));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", ctx_r3.disabledControls);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", ctx_r3.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.cardInfoForm.get("enotificationLastName").touched && (ctx_r3.cardInfoForm.get("enotificationLastName").errors == null ? null : ctx_r3.cardInfoForm.get("enotificationLastName").errors.required));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("readonly", ctx_r3.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.cardInfoForm.get("emailAddress").touched && (ctx_r3.cardInfoForm.get("emailAddress").errors == null ? null : ctx_r3.cardInfoForm.get("emailAddress").errors.required));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.cardInfoForm.get("emailAddress").touched && (ctx_r3.cardInfoForm.get("emailAddress").errors == null ? null : ctx_r3.cardInfoForm.get("emailAddress").errors.pattern));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", ctx_r3.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.cardInfoForm.get("mobilePhoneNumber").touched && (ctx_r3.cardInfoForm.get("mobilePhoneNumber").errors == null ? null : ctx_r3.cardInfoForm.get("mobilePhoneNumber").errors.required));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.cardInfoForm.get("mobilePhoneNumber").touched && (ctx_r3.cardInfoForm.get("mobilePhoneNumber").errors == null ? null : ctx_r3.cardInfoForm.get("mobilePhoneNumber").errors.pattern));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.cardInfoForm.get("mobilePhoneNumber").touched && (ctx_r3.cardInfoForm.get("mobilePhoneNumber").errors == null ? null : ctx_r3.cardInfoForm.get("mobilePhoneNumber").errors.maxlength));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.cardInfoForm.get("mobilePhoneNumber").touched && (ctx_r3.cardInfoForm.get("mobilePhoneNumber").errors == null ? null : ctx_r3.cardInfoForm.get("mobilePhoneNumber").errors.minlength));
} }
class CardInformationComponent {
    constructor(formBuilder, apiService, changeDetectorRef, cardInformationService, dynamicDialogConfig, toastr, store, stepStatusUpdatePayloadCostruction, cacheCountryService, referenceLibraryService, dialog) {
        this.formBuilder = formBuilder;
        this.apiService = apiService;
        this.changeDetectorRef = changeDetectorRef;
        this.cardInformationService = cardInformationService;
        this.dynamicDialogConfig = dynamicDialogConfig;
        this.toastr = toastr;
        this.store = store;
        this.stepStatusUpdatePayloadCostruction = stepStatusUpdatePayloadCostruction;
        this.cacheCountryService = cacheCountryService;
        this.referenceLibraryService = referenceLibraryService;
        this.dialog = dialog;
        this.showCardInfoSection = false;
        this.showENotificationSection = false;
        this.observableSubscription$ = new Subject();
        this.checkStateMondatory = false;
        this.extrAblDocEvdCatg = [];
        this.ccNumber1_hide = false;
        this.validExpiryDate = true;
        this.uscisStepConfig = {};
        this.listStates = [];
        this.listCountry = [];
        this.signatureImage = null;
        this.cardInfoForm = this.formBuilder.group({
            id: [null],
            petitionId: [this.dynamicDialogConfig.data.caseId],
            addressId: [null],
            enotificationId: [null],
            creditCardDetailsId: [null],
            isAuthCreditCardTrans: [0],
            firstName: ['', [Validators.required]],
            middleName: [''],
            lastName: ['', [Validators.required]],
            ccHolderFirstName: ['', [Validators.required]],
            ccHolderMiddleName: [''],
            ccHolderLastName: ['', [Validators.required]],
            ccHolderEmailAddress: ['', [Validators.required, Validators.email]],
            ccHolderPhoneNumber: ['', [Validators.required, Validators.pattern(/^-?(0|[0-9]\d*)?$/)]],
            ccNumber: [''],
            ccNumber1: [null, [Validators.required, Validators.pattern(/^[0-9]{4}$/)]],
            ccNumber2: [null, [Validators.required, Validators.pattern(/^[0-9]{4}$/)]],
            ccNumber3: [null, [Validators.required, Validators.pattern(/^[0-9]{4}$/)]],
            ccNumber4: [null, [Validators.required, Validators.pattern(/^[0-9]{4}$/)]],
            expiryDate: ['', Validators.required],
            creditCardType: ['', Validators.required],
            amount: ['', [Validators.required, Validators.pattern(/^-?(0|[0-9]\d*)?$/)]],
            isEnotifyReqd: [0],
            addressLine1: [''],
            addressLine2: [''],
            addressType: [''],
            city: ['', Validators.required],
            stateProvinceName: ['', Validators.required],
            postCode: [null, [Validators.required, Validators.pattern(/^[0-9]{5}$/)]],
            enotificationFirstName: ['', Validators.required],
            enotificationLastName: ['', Validators.required],
            enotificationMiddleName: [''],
            emailAddress: ['', [Validators.required, Validators.email]],
            mobilePhoneNumber: ['', [Validators.required, Validators.pattern(/^-?(0|[0-9]\d*)?$/)]],
            doorNo: ['']
        });
    }
    ngOnInit() {
        this.handleCountryChange('USA');
        this.uscisStepConfig.includeCreditCardInfo = true;
        this.uscisStepConfig.includeEnotificationInfo = true;
        combineLatest([
            this.store.pipe(select(getSubTaskDetails)),
            this.store.pipe(select(getStepDetails, { id: this.dynamicDialogConfig.data.stepId }))
        ]).pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.task = response[0];
            //   this.toggleControlsStatus();
            this.stepStatus = response[1].stepStatusDetails.stepStatusCode;
            this.stepDetails = response[1];
            if (this.stepDetails && this.stepDetails.additionalConfig && JSON.parse(this.stepDetails.additionalConfig).uscisStepConfig) {
                const uscisStepConfig = JSON.parse(this.stepDetails.additionalConfig).uscisStepConfig;
                if (uscisStepConfig) {
                    this.uscisStepConfig = uscisStepConfig.find(x => x.name === 'Show Card Information');
                    this.uscisStepConfig.includeCreditCardInfo = this.uscisStepConfig.includeCreditCardInfo ? this.uscisStepConfig.includeCreditCardInfo : true;
                    this.uscisStepConfig.includeEnotificationInfo = this.uscisStepConfig.includeEnotificationInfo ? this.uscisStepConfig.includeEnotificationInfo : true;
                }
                // console.log("this.uscisStepConfig #####",this.uscisStepConfig)
            }
            else {
                this.uscisStepConfig.includeCreditCardInfo = true;
                this.uscisStepConfig.includeEnotificationInfo = true;
            }
            if (this.stepStatus === 'COMPLETE' || this.stepStatus === 'NEW') {
                this.disabledControls = true;
            }
            else {
                this.disabledControls = false;
            }
        });
        this.referenceLibraryService.getReferenceData('CREDITCARDTYP').pipe(takeUntil(this.observableSubscription$)).subscribe(data => {
            if (data) {
                this.creditCardTypeArr = data;
            }
            else {
                this.creditCardTypeArr = [];
            }
        });
        this.updateValidators();
        this.getCardInfo();
        this.cardInfoForm.valueChanges.pipe(map$1(() => this.cardInfoForm.dirty)).pipe(takeUntil(this.observableSubscription$)).subscribe(dirty => {
            if (dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
    }
    // toggleControlsStatus() {
    //   this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
    // }
    getCardInfo() {
        this.cardInformationService.getEnotificationAndCCDetails(this.dynamicDialogConfig.data.visatype, this.dynamicDialogConfig.data.caseType, this.dynamicDialogConfig.data.caseId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            var _a;
            if (response.status === 200) {
                this.enotificationAndCCDetails = response.data;
                //  console.log("$$$ this.enotificationAndCCDetails", this.enotificationAndCCDetails);
                if (this.enotificationAndCCDetails) {
                    this.signatureImage = (this.enotificationAndCCDetails['ccHolderSignature'] !== null && this.enotificationAndCCDetails['ccHolderSignature'] !== undefined) ? `data:image/jpeg;base64,${this.enotificationAndCCDetails['ccHolderSignature']}` : '';
                    this.handleCountryChange('USA');
                    if (this.enotificationAndCCDetails.isAuthCreditCardTrans) {
                        this.handleCreditCardSelection(true);
                    }
                    if (this.enotificationAndCCDetails.isEnotifyReqd) {
                        this.handleCreditCardSelection(true, 'ENOTIFY');
                    }
                    this.cardInfoForm.patchValue({
                        id: this.enotificationAndCCDetails.id,
                        isAuthCreditCardTrans: this.enotificationAndCCDetails.isAuthCreditCardTrans ? true : false,
                        firstName: this.enotificationAndCCDetails.firstName,
                        middleName: this.enotificationAndCCDetails.middleName,
                        lastName: this.enotificationAndCCDetails.lastName,
                        ccHolderFirstName: this.enotificationAndCCDetails.ccHolderFirstName,
                        ccHolderMiddleName: this.enotificationAndCCDetails.ccHolderMiddleName,
                        ccHolderLastName: this.enotificationAndCCDetails.ccHolderLastName,
                        ccHolderEmailAddress: this.enotificationAndCCDetails.ccHolderEmailAddress,
                        ccHolderPhoneNumber: this.enotificationAndCCDetails.ccHolderPhoneNumber,
                        ccNumber: this.enotificationAndCCDetails.ccNumber ? this.enotificationAndCCDetails.ccNumber : '1234-5555-5777-8888',
                        expiryDate: this.enotificationAndCCDetails.expiryDate,
                        creditCardType: this.enotificationAndCCDetails.creditCardType,
                        petitionId: this.enotificationAndCCDetails.petitionId ? this.enotificationAndCCDetails.petitionId : this.dynamicDialogConfig.data.caseId,
                        amount: this.enotificationAndCCDetails.amount,
                        isEnotifyReqd: this.enotificationAndCCDetails.isEnotifyReqd ? true : false,
                        addressLine1: this.enotificationAndCCDetails.addressLine1,
                        addressLine2: this.enotificationAndCCDetails.addressLine2,
                        addressType: this.enotificationAndCCDetails.addressType ? this.enotificationAndCCDetails.addressType : 'Credit Card Billing',
                        city: this.enotificationAndCCDetails.city,
                        stateProvinceName: this.enotificationAndCCDetails.stateProvinceName,
                        postCode: this.enotificationAndCCDetails.postCode,
                        enotificationId: this.enotificationAndCCDetails.enotificationId,
                        enotificationFirstName: this.enotificationAndCCDetails.enotificationFirstName,
                        enotificationLastName: this.enotificationAndCCDetails.enotificationLastName,
                        enotificationMiddleName: this.enotificationAndCCDetails.enotificationMiddleName,
                        emailAddress: this.enotificationAndCCDetails.emailAddress,
                        mobilePhoneNumber: this.enotificationAndCCDetails.mobilePhoneNumber,
                        creditCardDetailsId: this.enotificationAndCCDetails.creditCardDetailsId,
                        addressId: this.enotificationAndCCDetails.addressId ? this.enotificationAndCCDetails.addressId : 0,
                        doorNo: this.enotificationAndCCDetails.doorNo
                    });
                    this.validExpiryDate = true;
                    // spliting the ccnumber to four box
                    const segments = [...(_a = this.enotificationAndCCDetails.ccNumber) === null || _a === void 0 ? void 0 : _a.match(/.{1,4}/g)];
                    if (segments && segments.length === 4) {
                        this.cardInfoForm.patchValue({
                            ccNumber1: segments[0],
                            ccNumber2: segments[1],
                            ccNumber3: segments[2],
                            ccNumber4: segments[3],
                        });
                    }
                    this.store.dispatch(new MarkCleanFormAction({
                        dirty: false
                    }));
                }
            }
        });
    }
    updateStepStatus(status) {
        this.store.dispatch(updateStepStatus({
            payload: this.stepStatusUpdatePayloadCostruction.payloadConstruction(this.stepDetails, status),
            subTaskId: this.stepDetails.taskId,
            stepId: this.dynamicDialogConfig.data.stepId,
            visaType: this.dynamicDialogConfig.data.caseType === 'I130' ?
                this.dynamicDialogConfig.data.caseType : this.dynamicDialogConfig.data.visatype
        }));
    }
    saveCardInfo() {
        let formData = this.cardInfoForm.value;
        // console.log("this.cardInfoForm.value", this.cardInfoForm.value);
        let payload = Object.assign(Object.assign({}, formData), { isAuthCreditCardTrans: formData.isAuthCreditCardTrans ? 1 : 0, isEnotifyReqd: formData.isEnotifyReqd ? 1 : 0, ccNumber: `${formData.ccNumber1}${formData.ccNumber2}${formData.ccNumber3}${formData.ccNumber4}` });
        const prop = ['ccNumber1', 'ccNumber2', 'ccNumber3', 'ccNumber4'];
        for (const p of prop) {
            delete payload[p];
        }
        // console.log("Payload", payload)
        this.cardInformationService.saveEnotificationAndCCDetails(this.dynamicDialogConfig.data.visatype, this.dynamicDialogConfig.data.caseType, this.dynamicDialogConfig.data.caseId, payload).subscribe(res => {
            this.cardInfoForm.reset();
            this.toastr.success(res.message, 'Success');
            if (this.signatureImageForm) {
                this.uploadSignImage();
            }
            else {
                this.getCardInfo();
            }
            // this.updateStepStatus('INPROGRESS');
        });
    }
    handleCountryChange(countryCode) {
        this.referenceLibraryService.getStatesFromStore(countryCode)
            .pipe(take(1))
            .subscribe((states) => {
            if (states) {
                this.listStates = states;
                this.changeDetectorRef.markForCheck();
            }
            else {
                this.referenceLibraryService.getStatesFromApi(countryCode)
                    .pipe(take(1))
                    .subscribe((data) => {
                    this.listStates = data;
                    this.changeDetectorRef.markForCheck();
                });
            }
        });
    }
    handleCreditCardSelection(val, sectionName) {
        if (sectionName === 'ENOTIFY') {
            this.showENotificationSection = val ? true : false;
        }
        else {
            this.showCardInfoSection = val ? true : false;
        }
        this.updateValidators();
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    uploadSignatureImage() {
        this.showCropperSection = false;
        const dialogRef = this.dialog.open(UploadSignatureLibraryComponent, {
            panelClass: 'custom-dialog'
        });
        dialogRef.afterClosed().subscribe(result => {
            this.sessionpicimage = sessionStorage.setItem("SesionpicValue", this.signatureImage);
            const file = this.dataURItoBlob(result);
            //  console.dir("blob", file);
            let reader = new FileReader();
            let self = this;
            reader.readAsDataURL(file);
            reader.onload = function () {
                self.signatureImage = reader.result;
            };
            reader.onerror = function (error) {
            };
            this.signatureImageForm = new FormData();
            this.signatureImageForm.append("file", file, "mysignature.png");
        });
    }
    uploadSignImage() {
        //this.cardInformationService.postSignatureImage(this.dynamicDialogConfig.data.caseId, this.signatureImageForm).subscribe((response) => {
        this.cardInformationService.postSignatureImage(this.dynamicDialogConfig.data.visatype, this.dynamicDialogConfig.data.caseType, this.dynamicDialogConfig.data.caseId, this.signatureImageForm).subscribe((response) => {
            if (response['status'] === 200) {
                this.toastr.success('Image Uploaded successfully', 'Success');
                this.getCardInfo();
            }
            else {
                CustomErrorToastComponent.showErrorToast(this.toastr, 'Image is not Uploaded successfully');
            }
        });
    }
    dataURItoBlob(dataURI) {
        const binary = atob(dataURI.split(',')[1]);
        const array = [];
        for (let i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i));
        }
        return new Blob([new Uint8Array(array)], {
            type: 'image/png',
        });
    }
    get f() {
        return this.cardInfoForm.controls;
    }
    updateValidators() {
        // if (!this.showCardInfoSection && !this.showENotificationSection) {
        //   this.validExpiryDate = true;
        //   Object.keys(this.cardInfoForm.controls).forEach(key => {
        //     const control = this.cardInfoForm.get(key);
        //     control.clearValidators();
        //     control.updateValueAndValidity();
        //   });
        // } 
        Object.keys(this.cardInfoForm.controls).forEach(key => {
            const control = this.cardInfoForm.get(key);
            control.clearValidators();
            control.updateValueAndValidity();
        });
        if (this.showENotificationSection) {
            // add validators back to each control
            this.validExpiryDate = true;
            this.cardInfoForm.get('enotificationFirstName').setValidators(Validators.required);
            this.cardInfoForm.get('enotificationLastName').setValidators(Validators.required);
            this.cardInfoForm.get('emailAddress').setValidators([Validators.required, Validators.email]);
            this.cardInfoForm.get('mobilePhoneNumber').setValidators([Validators.required, Validators.pattern(/^-?(0|[0-9]\d*)?$/)]);
            Object.keys(this.f).forEach(key => {
                const control = this.cardInfoForm.get(key);
                control.updateValueAndValidity();
            });
        }
        if (this.showCardInfoSection) {
            this.validExpiryDate = true;
            this.cardInfoForm.get('firstName').setValidators(Validators.required);
            this.cardInfoForm.get('lastName').setValidators(Validators.required);
            this.cardInfoForm.get('ccHolderFirstName').setValidators(Validators.required);
            this.cardInfoForm.get('ccHolderLastName').setValidators(Validators.required);
            this.cardInfoForm.get('expiryDate').setValidators(Validators.required);
            this.cardInfoForm.get('creditCardType').setValidators(Validators.required);
            this.cardInfoForm.get('city').setValidators(Validators.required);
            this.cardInfoForm.get('stateProvinceName').setValidators(Validators.required);
            this.cardInfoForm.get('ccHolderEmailAddress').setValidators([Validators.required, Validators.email]);
            this.cardInfoForm.get('ccHolderPhoneNumber').setValidators([Validators.required, Validators.pattern(/^-?(0|[0-9]\d*)?$/)]);
            this.cardInfoForm.get('ccNumber1').setValidators([Validators.required, Validators.pattern(/^[0-9]{4}$/)]);
            this.cardInfoForm.get('ccNumber2').setValidators([Validators.required, Validators.pattern(/^[0-9]{4}$/)]);
            this.cardInfoForm.get('ccNumber3').setValidators([Validators.required, Validators.pattern(/^[0-9]{4}$/)]);
            this.cardInfoForm.get('ccNumber4').setValidators([Validators.required, Validators.pattern(/^[0-9]{4}$/)]);
            this.cardInfoForm.get('amount').setValidators([Validators.required, Validators.pattern(/^-?(0|[0-9]\d*)?$/)]);
            this.cardInfoForm.get('postCode').setValidators([Validators.required, Validators.pattern(/^[0-9]{5}$/)]);
            Object.keys(this.cardInfoForm.controls).forEach(key => {
                const control = this.cardInfoForm.get(key);
                control.updateValueAndValidity();
            });
        }
    }
    validateExpiryDate() {
        let input = this.cardInfoForm.controls['expiryDate'].value;
        const pattern = /^(.*?)\//;
        const match = input.match(pattern);
        const result = match[1];
        var regex = new RegExp("^(0?[1-9]|1[0-2])$");
        this.validExpiryDate = regex.test(result) ? true : false;
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
CardInformationComponent.ɵfac = function CardInformationComponent_Factory(t) { return new (t || CardInformationComponent)(i0.ɵɵdirectiveInject(i1$1.FormBuilder), i0.ɵɵdirectiveInject(i2.APIConsulateAddress), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(CardInformationService), i0.ɵɵdirectiveInject(i4.DynamicDialogConfig), i0.ɵɵdirectiveInject(i5.ToastrService), i0.ɵɵdirectiveInject(i6.Store), i0.ɵɵdirectiveInject(i7.StepStatusUpdatePayloadService), i0.ɵɵdirectiveInject(i8.CacheCountryListService), i0.ɵɵdirectiveInject(i9.ReferenceLibraryService), i0.ɵɵdirectiveInject(i10.MatDialog)); };
CardInformationComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CardInformationComponent, selectors: [["card-information"]], decls: 13, vars: 7, consts: [[1, "row", "col-md-12", "pr-0", "mb-2"], [1, "heading"], [3, "formGroup"], [1, "row", "w-100"], ["class", "col-12 pl-0 mb-3", 4, "ngIf"], ["class", "row", 4, "ngIf"], [1, "col-12", "pl-0", "pb-2"], [1, "row", "mt-4", "ml-3"], [1, "col-2", "px-0"], ["pButton", "", "type", "submit", "label", "Save", "icon", "pi pi-save", 3, "ngClass", "disabled", "click"], [1, "col-12", "pl-0", "mb-3"], [1, "col-md-12", "input-disabled", "processing-dropdown"], [1, "row", "label-cls"], [1, "pl-0", "pt-3"], ["name", "isAuthCreditCardTrans", "formControlName", "isAuthCreditCardTrans", "label", "Yes", 1, "letter-radio", 3, "disabled", "value", "onClick"], ["name", "isAuthCreditCardTrans", "formControlName", "isAuthCreditCardTrans", "label", "No", 1, "letter-radio", 3, "disabled", "value", "onClick"], [1, "row"], [1, "label-cls", "label-title"], [1, "col-md-4", "form-group", "input-disabled"], [1, "label-cls", "required"], ["id", "firstName", "formControlName", "firstName", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], ["class", "invalid-message", 4, "ngIf"], [1, "label-cls"], ["id", "middleName", "formControlName", "middleName", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], ["id", "lastName", "formControlName", "lastName", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], ["id", "ccHolderFirstName", "formControlName", "ccHolderFirstName", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], ["id", "ccHolderMiddleName", "formControlName", "ccHolderMiddleName", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], ["id", "ccHolderLastName", "formControlName", "ccHolderLastName", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], ["id", "addressLine1", "formControlName", "addressLine1", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], ["formControlName", "addressLine2", "inputId", "apt", "value", "apt", "label", "Apt", 1, "letter-radio", 3, "disabled"], ["formControlName", "addressLine2", "inputId", "ste", "value", "ste", "label", "Ste", 1, "letter-radio", 3, "disabled"], ["formControlName", "addressLine2", "inputId", "flr", "value", "flr", "label", "Flr", 1, "letter-radio", 3, "disabled"], ["id", "doorNo", "formControlName", "doorNo", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], ["id", "city", "formControlName", "city", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], [1, "col-md-4", "form-group", "processing-dropdown"], ["appendTo", "body", "id", "stateProvinceName", "formControlName", "stateProvinceName", "optionLabel", "stateProvinceName", "optionValue", "stateProvinceCode", "placeholder", "select", 3, "disabled", "options"], ["id", "postCode", "formControlName", "postCode", "type", "text", "pInputText", "", "placeholder", "Enter", "minlength", "5", "maxlength", "5", 1, "im-input", "mw-100", 3, "readonly"], [1, "col-4", "linehgt10"], ["type", "button", "title", ".png only", 3, "ngClass", "disabled", "click"], [1, "col-8", "linehgt10"], ["class", "signatureImageBox", 3, "src", 4, "ngIf"], [1, "col-md-6", "form-group", "input-disabled"], ["id", "ccHolderPhoneNumber", "formControlName", "ccHolderPhoneNumber", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], ["id", "ccHolderEmailAddress", "formControlName", "ccHolderEmailAddress", "type", "text", "pInputText", "", "placeholder", "Enter", "pattern", "[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$", 1, "im-input", "mw-100", 3, "readonly"], [1, "col-md-3", "ml-0", "pl-0"], ["type", "text", "formControlName", "ccNumber1", "minlength", "4", "maxlength", "4", 3, "ngClass"], [1, "hypen"], ["type", "text", "autocomplete", "off", "id", "ccNumber2", "formControlName", "ccNumber2", "maxlength", "4", 3, "ngClass"], ["type", "text", "autocomplete", "off", "id", "ccNumber3", "formControlName", "ccNumber3", "minlength", "4", "maxlength", "4", 3, "ngClass"], ["type", "text", "autocomplete", "off", "id", "ccNumber4", "formControlName", "ccNumber4", "maxlength", "4"], [1, "matIconStyle"], ["matSuffix", "", "matTooltip", "Show/Hide", 3, "click"], [1, "col-md-3", "ml-0", "pl-0", "invalid-message"], [4, "ngIf"], [1, "col-md-2", "form-group", "input-disabled"], ["slotChar", "", "placeholder", "MM/YYYY", "mask", "99/9999", "id", "expiryDate", "formControlName", "expiryDate", 3, "readonly", "onComplete"], [1, "required"], ["class", "p-field-checkbox", 4, "ngFor", "ngForOf"], ["id", "paymentAmount", "formControlName", "amount", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], [1, "invalid-message"], [1, "signatureImageBox", 3, "src"], [1, "p-field-checkbox"], ["formControlName", "creditCardType", 3, "inputId", "value"], [1, "label-cls", 3, "for"], ["name", "isEnotifyReqd", "formControlName", "isEnotifyReqd", "label", "Yes", 1, "letter-radio", 3, "disabled", "value", "onClick"], ["name", "isEnotifyReqd", "formControlName", "isEnotifyReqd", "label", "No", 1, "letter-radio", 3, "disabled", "value", "onClick"], ["id", "efirstName", "formControlName", "enotificationFirstName", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], ["id", "emiddleName", "formControlName", "enotificationMiddleName", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], ["id", "enotificationLastName", "formControlName", "enotificationLastName", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], ["id", "eEmailAddress", "formControlName", "emailAddress", "type", "text", "pInputText", "", "placeholder", "Enter", "pattern", "[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$", 1, "im-input", "mw-100", 3, "readonly"], ["formControlName", "mobilePhoneNumber", "maxlength", "10", "minlength", "10", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"]], template: function CardInformationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "h6", 1);
        i0.ɵɵtext(2, "E-Notify / Card Information");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "form", 2);
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵtemplate(5, CardInformationComponent_div_5_Template, 10, 4, "div", 4);
        i0.ɵɵtemplate(6, CardInformationComponent_div_6_Template, 143, 54, "div", 5);
        i0.ɵɵtemplate(7, CardInformationComponent_div_7_Template, 7, 4, "div", 4);
        i0.ɵɵtemplate(8, CardInformationComponent_div_8_Template, 33, 13, "div", 5);
        i0.ɵɵelementStart(9, "div", 6);
        i0.ɵɵelementStart(10, "div", 7);
        i0.ɵɵelementStart(11, "div", 8);
        i0.ɵɵelementStart(12, "button", 9);
        i0.ɵɵlistener("click", function CardInformationComponent_Template_button_click_12_listener() { return ctx.saveCardInfo(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("formGroup", ctx.cardInfoForm);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.uscisStepConfig.includeCreditCardInfo);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showCardInfoSection);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.uscisStepConfig.includeEnotificationInfo);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showENotificationSection);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", ctx.cardInfoForm.invalid || !ctx.validExpiryDate || ctx.disabledControls ? "btn-success button-width-icon-left mr-3 pl-4 pr-4 btn-success_disabled save-btn" : "btn-success button-width-icon-left mr-3  pl-4 pr-4 save-btn")("disabled", ctx.cardInfoForm.invalid || !ctx.validExpiryDate || ctx.disabledControls);
    } }, directives: [i1$1.ɵangular_packages_forms_forms_ba, i1$1.NgControlStatusGroup, i1$1.FormGroupDirective, i11.NgIf, i12.ButtonDirective, i11.NgClass, i13.RadioButton, i1$1.NgControlStatus, i1$1.FormControlName, i1$1.DefaultValueAccessor, i14.InputText, i15.Dropdown, i1$1.MinLengthValidator, i1$1.MaxLengthValidator, i1$1.PatternValidator, i16.MatIcon, i17.InputMask, i11.NgForOf], styles: [".label-title[_ngcontent-%COMP%]{padding-left:16px;padding-bottom:10px;font-weight:600}.step-title[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#3d3d63;font:normal normal 700 21px/32px Source Sans Pro}.step-title[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#626262;font:normal normal normal 13px/22px Source Sans Pro}.hypen[_ngcontent-%COMP%]{position:absolute;top:46%;border-top:2px solid #a7a4a4;width:11px;left:93%}.signatureImageBox[_ngcontent-%COMP%]{border:1px dotted;max-width:100px;max-height:100px;padding:5px;margin-bottom:5px;margin-top:35px}.ssn-input-hide[_ngcontent-%COMP%]{-webkit-text-security:disc}.matIconStyle[_ngcontent-%COMP%]{position:absolute;top:7px;left:100%}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardInformationComponent, [{
        type: Component,
        args: [{
                selector: 'card-information',
                templateUrl: 'card-information.component.html',
                styleUrls: ['card-information.component.scss']
            }]
    }], function () { return [{ type: i1$1.FormBuilder }, { type: i2.APIConsulateAddress }, { type: i0.ChangeDetectorRef }, { type: CardInformationService }, { type: i4.DynamicDialogConfig }, { type: i5.ToastrService }, { type: i6.Store }, { type: i7.StepStatusUpdatePayloadService }, { type: i8.CacheCountryListService }, { type: i9.ReferenceLibraryService }, { type: i10.MatDialog }]; }, null); })();

class CardInformationModule {
}
CardInformationModule.ɵfac = function CardInformationModule_Factory(t) { return new (t || CardInformationModule)(); };
CardInformationModule.ɵmod = i0.ɵɵdefineNgModule({ type: CardInformationModule });
CardInformationModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[PrimengLibraryModule, ReactiveFormsModule, MatDialogModule, UploadSignatureLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CardInformationModule, { declarations: [CardInformationComponent], imports: [PrimengLibraryModule, ReactiveFormsModule, MatDialogModule, UploadSignatureLibraryModule], exports: [CardInformationComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardInformationModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    CardInformationComponent
                ],
                imports: [PrimengLibraryModule, ReactiveFormsModule, MatDialogModule, UploadSignatureLibraryModule
                ],
                exports: [
                    CardInformationComponent,
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of card-information
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CardInformationComponent, CardInformationModule, CardInformationService };
//# sourceMappingURL=card-information.js.map
